import React from "react";
import { Route, Routes } from "react-router-dom";
import Logins from "../pages/login";
import Wallet from "../pages/wallet";
import Contacts from "../pages/contacts";
import News from "../pages/news";
import Settings from "../pages/settings";
import { AppProviders } from "../contexts/AppProviders";
import ProtectedRoute from "./protectRoute/index";

const RouteApp: React.FC = () => {
  return (
    <AppProviders>
      <Routes>
        {/* Rota pública */}
        <Route path="/" element={<Logins />} />

        {/* Rotas protegidas */}

        <Route
          path="/wallet"
          element={
            <ProtectedRoute>
              <Wallet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/news"
          element={
            <ProtectedRoute>
              <News />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contacts"
          element={
            <ProtectedRoute>
              <Contacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/config"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AppProviders>
  );
};

export default RouteApp;
